/* eslint-disable no-param-reassign */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import { isFunction } from 'lodash';
import React, { memo, useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import Button from 'layout/atoms/Button/Button';
import { closeScreenshot } from 'store/chatSlice';
import { closeSidebar } from 'store/layoutSlice';
import getElementBoundaries from 'utils/getElementBoundaries';
import getElementOffset from 'utils/getElementOffset';
import './CropArea.scss';
import SizeControls from './SizeControls/SizeControls';
const setBackgroundPosition = (cropRef, imgRef) => {
    const offset = getElementOffset(cropRef.current);
    imgRef.current.style.left = `${-offset.x}px`;
    imgRef.current.style.top = `${-offset.y}px`;
};
function CropArea({ data, onCrop }) {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const [anchorPoint, setAnchorPoint] = useState(null);
    const cancel = useRef(() => {
        setAnchorPoint(null);
        document.removeEventListener('mouseup', cancel.current);
    });
    const resizing = useRef(false);
    const cropRef = useRef(null);
    const imgRef = useRef(null);
    useEffect(() => {
        if (cropRef.current) {
            const offset = getElementOffset(cropRef.current);
            imgRef.current.style.width = `${window.innerWidth}px`;
            imgRef.current.style.height = `${window.innerHeight}px`;
            imgRef.current.style.left = `${-offset.x}px`;
            imgRef.current.style.top = `${-offset.y}px`;
        }
    }, []);
    const handleMouseMove = (e) => {
        if (anchorPoint && !resizing.current) {
            cropRef.current.style.left = `${e.clientX - anchorPoint.x}px`;
            cropRef.current.style.top = `${e.clientY - anchorPoint.y}px`;
            setBackgroundPosition(cropRef, imgRef);
        }
    };
    const handleMouseDown = (e) => {
        if (resizing.current)
            return;
        const offset = getElementOffset(e.currentTarget);
        const rx = e.clientX - offset.x;
        const ry = e.clientY - offset.y;
        setAnchorPoint({ x: rx, y: ry });
        document.addEventListener('mouseup', cancel.current);
    };
    const handleMouseUp = () => {
        setAnchorPoint(null);
        document.removeEventListener('mouseup', cancel.current);
    };
    const handleResize = () => {
        setBackgroundPosition(cropRef, imgRef);
        resizing.current = true;
    };
    const handleResizeStop = () => {
        resizing.current = false;
    };
    const handleCrop = () => {
        const boundary = getElementBoundaries(cropRef.current);
        if (isFunction(onCrop))
            onCrop(boundary);
    };
    return (React.createElement("div", { className: "CropArea" },
        React.createElement("div", { className: "CropArea__backdrop" }),
        React.createElement("div", { className: "CropArea__crop", ref: cropRef, onMouseDown: handleMouseDown, onMouseUp: handleMouseUp, onMouseMove: handleMouseMove },
            React.createElement(SizeControls, { onResize: handleResize, onResizeStop: handleResizeStop, ref: cropRef }),
            React.createElement("div", { className: "lines lines--vertical" }),
            React.createElement("div", { className: "lines lines--horizontal" }),
            React.createElement("div", { className: "crop__image--container" },
                React.createElement("img", { src: data, ref: imgRef, alt: "backdrop" })),
            React.createElement("div", { className: "crop_buttons" },
                React.createElement(Button, { theme: "ghost", onClick: () => {
                        dispatch(closeScreenshot());
                        dispatch(closeSidebar({ name: 'screenshot' }));
                    } }, t('cancel')),
                React.createElement(Button, { color: "primary", onClick: handleCrop }, t('ok'))))));
}
export default memo(CropArea);
